import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityCouponApi } from 'api';

export const findEntityCouponForTableList = createAsyncThunk(
  'entityCoupon/findEntityCouponForTableList',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await EntityCouponApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityCoupon = createAsyncThunk(
  'entityCoupon/findEntityCoupon',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await EntityCouponApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityCoupon = createAsyncThunk(
  'entityCoupon/createEntityCoupon',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityCouponApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityCoupon = createAsyncThunk(
  'entityCoupon/findOneEntityCoupon',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, option } = params;
      const response = await EntityCouponApi.findOne(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityCoupon = createAsyncThunk(
  'entityCoupon/updateEntityCoupon',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityCouponApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
};

const couponSlice = createSlice({
  name: 'entityCoupon',
  initialState,
  reducers: {
    reloadEntityCoupon(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(findEntityCouponForTableList.fulfilled, (state, action) => {
        const { data } = action.payload;

        const newData = data.map(item => {
          return {
            ...item,
            key: item.id,
            value: item.id,
          };
        });

        state.tableList = newData;
      })
      .addCase(findEntityCoupon.fulfilled, (state, action) => {
        const { data } = action.payload;

        const newData = data.map(item => {
          return {
            ...item,
            key: item.id,
            value: item.id,
          };
        });

        state.list = newData;
      });
  },
});

const { actions, reducer: couponReducer } = couponSlice;

export const { reloadEntityCoupon } = actions;

export default couponReducer;
